var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2538 0L6.62842 3.38397L7.48466 1.39161L11.2538 0Z",
    fill: "#E27625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.587891 0L5.16742 3.41439L4.34938 1.39161L0.587891 0Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58733 7.84033L8.35645 9.70339L10.9864 10.4182L11.7433 7.88593L9.58733 7.84033Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0991211 7.88593L0.848358 10.4182L3.47834 9.70339L2.25509 7.84033L0.0991211 7.88593Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33323 4.70739L2.60693 5.7948L5.21399 5.90887L5.12223 3.14087L3.33323 4.70739Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50151 4.70754L6.68958 3.1106L6.62842 5.90901L9.23544 5.79494L8.50151 4.70754Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 9.70364L5.05344 8.95079L3.70023 7.90137L3.47852 9.70364Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78174 8.95079L8.35669 9.70364L8.14262 7.90137L6.78174 8.95079Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35669 9.70353L6.78174 8.95068L6.91174 9.95447L6.89644 10.3879L8.35669 9.70353Z",
    fill: "#D7C1B3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 9.70353L4.93877 10.3879L4.93112 9.95447L5.05344 8.95068L3.47852 9.70353Z",
    fill: "#D7C1B3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96946 7.23229L3.66211 6.85209L4.58718 6.43384L4.96946 7.23229Z",
    fill: "#2F343B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87354 7.23229L7.25578 6.43384L8.18087 6.85209L6.87354 7.23229Z",
    fill: "#2F343B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47862 9.70339L3.70798 7.84033L2.25537 7.88593L3.47862 9.70339Z",
    fill: "#CC6228"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13477 7.84033L8.35649 9.70339L9.58737 7.88593L8.13477 7.84033Z",
    fill: "#CC6228"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23544 5.79517L6.62842 5.90924L6.87305 7.23239L7.25533 6.43395L8.18039 6.85216L9.23544 5.79517Z",
    fill: "#CC6228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66198 6.85216L4.58707 6.43395L4.96932 7.23239L5.21399 5.90924L2.60693 5.79517L3.66198 6.85216Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60693 5.79517L3.70021 7.90159L3.66198 6.85216L2.60693 5.79517Z",
    fill: "#E27625"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1803 6.85216L8.14209 7.90159L9.23536 5.79517L8.1803 6.85216Z",
    fill: "#E27625"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21387 5.90869L4.96924 7.23189L5.27503 8.7908L5.34383 6.73759L5.21387 5.90869Z",
    fill: "#E27625"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62899 5.90869L6.49902 6.72998L6.56783 8.7908L6.87362 7.23189L6.62899 5.90869Z",
    fill: "#E27625"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87366 7.23224L6.56787 8.79115L6.78191 8.95086L8.14279 7.90144L8.181 6.85205L6.87366 7.23224Z",
    fill: "#F5841F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66211 6.85205L3.70034 7.90144L5.05357 8.95086L5.27525 8.79115L4.96946 7.23224L3.66211 6.85205Z",
    fill: "#F5841F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89598 10.3875L6.91124 9.9541L6.79657 9.85522H5.04579L4.93112 9.9541L4.93877 10.3875L3.47852 9.70312L3.99073 10.1138L5.03049 10.821H6.80422L7.85163 10.1138L8.35623 9.70312L6.89598 10.3875Z",
    fill: "#C0AD9E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78134 8.95072L6.56727 8.79102H5.27519L5.05351 8.95072L4.93115 9.95451L5.04586 9.85562H6.79663L6.9113 9.95451L6.78134 8.95072Z",
    fill: "#2F343B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4454 3.6045L11.8353 1.73381L11.2542 0L6.78174 3.26991L8.50196 4.70714L10.9332 5.39917L11.4683 4.78319L11.2313 4.61591L11.6059 4.28131L11.3231 4.06836L11.69 3.78701L11.4454 3.6045Z",
    fill: "#763E1A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.73381L0.397556 3.6045L0.14526 3.78701L0.519879 4.06836L0.237003 4.28131L0.603978 4.61591L0.374619 4.78319L0.909789 5.39917L3.33335 4.70714L5.05353 3.26991L0.588686 0L0 1.73381Z",
    fill: "#763E1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9326 5.39955L8.50139 4.70752L9.23536 5.79497L8.14209 7.90139L9.58704 7.88616H11.743L10.9326 5.39955Z",
    fill: "#F5841F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33308 4.70752L0.909524 5.39955L0.0991211 7.88616H2.25509L3.70005 7.90139L2.60678 5.79497L3.33308 4.70752Z",
    fill: "#F5841F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62839 5.90888L6.7813 3.27014L7.48467 1.39185H4.3501L5.05347 3.27014L5.21403 5.90888L5.26754 6.74535L5.27519 8.79095H6.56723V6.74535L6.62839 5.90888Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.d0b6ba101d0df814936c5d3632cbc414.svg";
export { ForwardRef as ReactComponent };